<template>
  <section class="d-flex">
    <div class="w-100">
      <b-icon-plus
        v-if="editable && shouldShowAddButton"
        role="button"
        @click="addNewStatSection"
      />

      <div class="font-weight-bold mb-2" style="font-size: 24px">
        <EditableField
          :editable="editable"
          v-model="localSection.title"
          name="title"
          placeholder="Type the title here"
          @editable_field:save="updateTitle"
        />
      </div>

      <div class="d-grid" :style="gridStyle">
        <div class="d-flex flex-column" style="gap: 4px" v-if="localSection['first_stat']">
          <StatSection
            :case-study-id="caseStudyId"
            :section="localSection['first_stat']"
            :editable="editable"
            :accent-color="accentColor"
            :position="'first_stat'"
            @stat-updated="saveStatSection"
            @icon-selected="iconSelected"
          />
          <b-icon-trash
            v-if="editable"
            role="button"
            @click="deleteStatSection('first_stat')"
          ></b-icon-trash>
        </div>
        <div class="d-flex flex-column" style="gap: 4px" v-if="localSection['second_stat']">
          <StatSection
            :case-study-id="caseStudyId"
            :section="localSection['second_stat']"
            :editable="editable"
            :accent-color="accentColor"
            :position="'second_stat'"
            @stat-updated="saveStatSection"
            @icon-selected="iconSelected"
          />
          <b-icon-trash
            v-if="editable"
            role="button"
            @click="deleteStatSection('second_stat')"
          ></b-icon-trash>
        </div>
      </div>
    </div>
    <div class="d-flex align-items-center ml-1">
      <SectionControls :case-study-id="caseStudyId" :index="index" class="mt-2" v-if="editable" />
    </div>
  </section>
</template>

<script>
import SectionMixin from '@app/mixins/case_study_section'
import SectionControls from '@components/case_study_sections/SectionControls.vue'
import StatSection from '@components/case_study_sections/StatSection.vue'
import { useCaseStudyStore } from '@app/stores/CaseStudyStore'
import EditableField from '@app/components/EditableField.vue'

export default {
  name: 'KeyStatisticsSection',
  components: { SectionControls, StatSection, EditableField },
  mixins: [SectionMixin],
  props: {
    caseStudyId: { type: Number, required: true },
    accentColor: { type: String, required: true },
    index: { type: Number, required: true },
    editable: { type: Boolean, required: false, default: false },
    section: { type: Object, required: true },
  },
  data() {
    return {
      localSection: { ...this.section },
    }
  },
  watch: {
    section: {
      handler(newSection) {
        this.localSection = { ...newSection }
      },
      deep: true,
    },
  },
  computed: {
    editableText() {
      return this.editable ? true : null
    },
    // If the section is missing either the first or second stat, show the Plus icon
    shouldShowAddButton() {
      return !this.localSection['first_stat'] || !this.localSection['second_stat']
    },
    keyStatisticsWrapperClass() {
      return {
        'key-statistics__wrapper': true,
      }
    },
    gridStyle() {
      return {
        display: 'grid',
        'grid-template-columns': 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: '16px',
      }
    },
  },
  methods: {
    missingSection() {
      if (this.localSection['first_stat'] === null) return 'first_stat'
      return 'second_stat'
    },
    addNewStatSection() {
      const updatedSection = {
        ...this.localSection,
        [this.missingSection()]: {
          icon: 'arrow-down-left',
          title: 'reduction',
          value: '30%',
          caption: 'Enter text here',
        },
      }
      useCaseStudyStore().updateSection(this.caseStudyId, this.index, updatedSection)
    },
    // Deleting a StatSection actually means updating it with setting either the first/second as null.
    // If it is the only stat, we delete the entire KeyStatisticsSection.
    deleteStatSection(position) {
      if (!this.editable) return
      if (!confirm('Are you sure about deleting this section?')) return

      const newSection = { ...this.localSection, [position]: null }

      // If both stats are null, delete the entire KeyStatisticsSection
      if (newSection['first_stat'] === null && newSection['second_stat'] === null) {
        useCaseStudyStore().deleteSection(this.caseStudyId, this.index)
      } else {
        useCaseStudyStore().updateSection(this.caseStudyId, this.index, newSection)
      }
    },
    updateTitle(newContent) {
      const newSection = {
        ...this.localSection,
        title: newContent,
      }

      useCaseStudyStore().updateSection(this.caseStudyId, this.index, newSection)
    },
    // `position` is either 'first_stat' or 'second_stat'
    saveStatSection(section, fieldName, newContent, position) {
      const newSection = {
        ...this.localSection,
        [position]: { ...this.localSection[position], [fieldName]: newContent },
      }
      useCaseStudyStore().updateSection(this.caseStudyId, this.index, newSection)
    },
    iconSelected(icon, position) {
      const newSection = {
        ...this.localSection,
        [position]: { ...this.localSection[position], icon: icon },
      }
      useCaseStudyStore().updateSection(this.caseStudyId, this.index, newSection)
    },
  },
}
</script>
<style lang="sass" scoped></style>
